/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CommonBookingInfoViewBasketPassengersItemsInnerPassenger interface.
 */
export function instanceOfCommonBookingInfoViewBasketPassengersItemsInnerPassenger(value) {
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function CommonBookingInfoViewBasketPassengersItemsInnerPassengerFromJSON(json) {
    return CommonBookingInfoViewBasketPassengersItemsInnerPassengerFromJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketPassengersItemsInnerPassengerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dateOfBirth': (new Date(json['date_of_birth'])),
        'name': json['name'],
    };
}
export function CommonBookingInfoViewBasketPassengersItemsInnerPassengerToJSON(json) {
    return CommonBookingInfoViewBasketPassengersItemsInnerPassengerToJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketPassengersItemsInnerPassengerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'date_of_birth': ((value['dateOfBirth']).toISOString().substring(0, 10)),
        'name': value['name'],
    };
}
